import React from "react";

export default function ZwitserseFoto(props) {
  const zwiterse_link = props.link;

  let modkey = zwiterse_link.split("&modkey=")[1].split("&orikey=")[0],
    // orikey,
    // herstnr = zwiterse_link.split("&herstNr=")[1],
    oribild_exists = false,
    oribild;

  if (zwiterse_link.indexOf("&oribild=") > 0) {
    oribild_exists = true;
  }

  if (oribild_exists) {
    // orikey = zwiterse_link.split("&orikey=")[1].split("&oribild=")[0];
    oribild = zwiterse_link.split("&oribild=")[1].split("&herstNr=")[0];
  } else {
    // orikey = zwiterse_link.split("&orikey=")[1].split("&herstNr=")[0];
    oribild = modkey + "-0";
  }

  console.log(modkey);
  let Model_Groep = Math.ceil((Number(modkey) + 1) / 100);

  return (
    <img
      src={`https://unimog.ch/unimog/modelle/bild${Model_Groep}/${oribild}.jpg`}
      style={{ width: "100%", borderRadius: 7, border: "black 2px solid" }}
      alt=""
    ></img>
  );
}
